module.exports = __webpack_public_path__ + "img/04-3-1banner.42e0b613.png";